import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Assuming you're using react-bootstrap
import { AiFillCloseCircle } from "react-icons/ai";
import "./Store.scss"

const CartModal = ({ show, onClose, cartItems, onRemoveFromCart, onCartPayment, totalPrice }) => {

  const styles = {
    backgroundColor: "#F0F0F0",
    borderRadius: "5px",
    padding: "0px 40px",
  
  }

  const HeadStyle = {
    backgroundColor: "#F0F0F0",
  }

   // Convert bytes to a readable format
   const formatFileSize = (bytes) => {
    if (bytes === null) return 'N/A';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  };
  return (
    <Modal show={show} onHide={onClose} centered >
      <Modal.Header closeButton style={HeadStyle}>
        <Modal.Title>Your Cart</Modal.Title>
      </Modal.Header>
      <Modal.Body style={styles}>
        {cartItems.length > 0 ? (
          <>
            <table className="table">
              <thead>
                <tr>
                  <th></th>
                  <th>Item Name</th>
                  <th>Price</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.map(item => (
                  <tr key={item.id}>
                    <td className="cart-image">
                      {item.category !== 'Video Template' ? (
                        <img src={item.thumbnail} alt={item.name} style={{ width: '100px', height: 'auto' }} />
                      ) : (
                        <video width="100" height="auto" autoPlay loop muted poster={item.thumbnail} className='imageImg'>
                          <source src={item.thumbnail} type={'video/mp4'} />
                          Your browser does not support the video tag.
                        </video>
                      )}
                    </td>
                    <td className='item-name-here'><div className="tre">{item.name} <small>{formatFileSize(item.fileSize)}</small></div></td>
                    <td className='pricey'>₦{new Intl.NumberFormat("en-NG").format(item.price)}</td>
                    <td className="center-btn">
                      <AiFillCloseCircle className='remove' onClick={() => onRemoveFromCart(item.id)} />
                    </td>
                  </tr>
                ))}
                {/* Total Price Row */}
                <tr>
                  <td colSpan="3" style={{ textAlign: 'right' }}>Total Price:</td>
                  <td>₦{new Intl.NumberFormat("en-NG").format(totalPrice.toFixed(2))}</td>
                </tr>
              </tbody>
            </table>
          </>
        ) : (
          <p>Your cart is empty.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className='ClosePayBtn' onClick={onClose}>
          Close
        </Button>
        <Button className='PayBtn' onClick={onCartPayment}>
          Proceed to Payment
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CartModal;